import React, { Component } from 'react';
import Navbar from './navbar';
import Footer from '../components/footer';


export default class AuthApp extends Component {
  render() {
    return (
      <div>
        <Navbar /> <br />
        <div className="row" id="push">
          { this.props.children }
        </div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/auth_app.js